





















































































import moment from 'moment'
import settings from '@/settings.coffee'
import DropDown from '@/components/DropDown'

export default {
  name: "Reports"
  components:{
    DropDown
  }
  props:{
    establishments: Array
    reports_access: Object
    currentEstablishment: Object
  }
  data: ()->
      monthes: moment.months().map (el)->
          return {name:el}
      month: null
      year: null
      reportLink: null
      pdfLink: null
  computed:
    lastreport: ()->
      ret = @currentEstablishment.report_set[0]
      
      return ret
    years: ()->
      ret = []
      year = 2019
      while year <= moment().year()
         ret.push({name: year.toString()})
         year += 1
      return ret
    iframeHeight: ()->
      return 4000;
  methods:{
    getMonth: (str)->
      return moment(str).format("MMMM YYYY")
    getReportLink: (uid)->
      return settings.backendUrl+"/admin/showreport/"+uid+"/"
    monthClicked: (month)->
      @month = month
      found = false
      for r in @currentEstablishment.report_set
          m = moment(r.period_start)
          #console.log(m.format("YYYY") == @year, m.year(), @year, m.format("MMMM") == @month, m.month(), @month)
          if m.format("YYYY") == @year.name and m.format("MMMM") == @month.name
              @loadReport(r.uid)
              found = true
      if not found
          @pdfLink = null
          @reportLink = null

    yearClicked: (year)->
      @year = year
      found = false
      for r in @currentEstablishment.report_set
          m = moment(r.period_start)
          #console.log(m.format("YYYY") == @year, m.year(), @year, m.format("MMMM") == @month, m.month(), @month)
          if m.format("YYYY") == @year.name and m.format("MMMM") == @month.name
              @loadReport(r.uid)
              found = true
      if not found
          @reportLink = null
          @pdfLink = null
    loadReport: (uid)->
      @reportLink = @getReportLink(uid)
      @pdfLink = settings.backendMediaUrl+"reports/"+uid+".pdf"
  }
  mounted: ()->
    setTimeout(()->
          new AcornIcons().replace()
          # -- defined in /public/js/scripts
          #scripts = new Scripts();
          setTimeout(()->
              $('.datepicker').datepicker({autoclose:true, format:"dd/mm/yyyy"});
              return
          ,2000)
          return
    ,100)
    
    m = moment(@currentEstablishment.report_set[0].period_start)
    
    @month = {"name": m.format("MMMM")}
    @year = {"name": m.format("YYYY")}
    @loadReport(@currentEstablishment.report_set[0].uid)
}
